import {z} from 'zod'
import {ProjectId} from '../projects/index.js'
import {ConnectionId} from './ConnectionId.js'
import {GitHubRepository} from '../github/index.js'

const BaseConnection = z.object({
  id: ConnectionId,
  type: z.string(),
  name: z.string().trim().min(1),
  lastRefreshTime: z.string().nullish(),
  deletionTime: z.string().nullish(),
})

export const ICalSubscriptionConnection = BaseConnection.extend({
  type: z.literal('ical-subscription'),
  url: z.string().url(),
  projectId: ProjectId.nullish(),
})
export type ICalSubscriptionConnection = z.infer<typeof ICalSubscriptionConnection>

export const GitHubApiKey = z.string().startsWith('ghp_')
export const GitHubApiConnection = BaseConnection.extend({
  type: z.literal('github-api'),
  maskedApiKey: GitHubApiKey.endsWith('***'),
  repositories: z.array(GitHubRepository),
})
export type GitHubApiConnection = z.infer<typeof GitHubApiConnection>

export const JiraApiKey = z.string()
export const JiraApiConnection = BaseConnection.extend({
  type: z.literal('jira-api'),
  domain: z.string().url(),
  projectKey: z.string(),
  username: z.string().email(),
  maskedApiKey: JiraApiKey.endsWith('***'),
  projectId: ProjectId.nullish(),
})
export type JiraApiConnection = z.infer<typeof JiraApiConnection>

export const Connection = z.union([ICalSubscriptionConnection, GitHubApiConnection, JiraApiConnection])
export type Connection = z.infer<typeof Connection>
